export type GalleryKind = "artist" | "exhibition" | "collector";
export interface ArchiveWork {
  inscriptionId: string;
  title: string;
  year: string;
  series: string;
  statement: string;
  edition: string;
}
export interface GalleryInput {
  kind: GalleryKind;
  title: string;
  description: string;
  process: string;
  curator: string;
  opensAt: number | null;
  theme: "ink" | "paper" | "lavender";
  published: boolean;
  anonymous: boolean;
  works: ArchiveWork[];
}
export interface ArtefactGallery extends GalleryInput {
  id: string;
  revision: number;
  createdAt: number;
  updatedAt: number;
  curatorUsername: string | null;
  curatorName: string;
  curatorBio: string;
  ownershipCheckedAt: number | null;
}
export interface ArtworkPassport {
  id: string;
  number: number | null;
  contentType: string;
  contentLength: number | null;
  genesisHeight: number | null;
  timestamp: number | null;
  satpoint: string;
  address: string;
  parents: string[];
  children: string[];
  childCount: number;
  delegate: string | null;
  properties: unknown;
}
export interface ArtWatch {
  auctionId: string;
  targetSats: number | null;
}
export interface ArtNotice {
  id: string;
  auctionId: string;
  title: string;
  message: string;
  kind: "opening" | "outbid" | "target" | "closed";
  read: boolean;
}
export interface ArtInbox {
  follows: string[];
  watches: ArtWatch[];
  notices: ArtNotice[];
}

/** Keep every new call same-origin and use the shared wallet's Bearer proof. */
export async function artefactApi<T>(
  path: string,
  token?: string | null,
  body?: unknown,
): Promise<T> {
  const response = await fetch(`/api/artefact/community${path}`, {
    method: body === undefined ? "GET" : "POST",
    headers: {
      ...(token ? { authorization: `Bearer ${token}` } : {}),
      ...(body === undefined ? {} : { "content-type": "application/json" }),
    },
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  const data = (await response.json()) as T & { error?: string };
  if (!response.ok)
    throw new Error(data.error ?? "The archive is temporarily unavailable");
  return data;
}
